import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import logo from "../logo-leasein.png";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [parola, setParola] = useState("");
  const [eroare, setEroare] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEroare("");
    const rez = await login(email, parola);
    if (rez.ok) {
      navigate("/portal");
    } else {
      setEroare(rez.eroare);
    }
  };

  return (
    <div className="login">
      <div className="login__card">
        <Link to="/" className="login__logo">
          <img src={logo} alt="LEASEIN" />
        </Link>
        <h1>Cont client</h1>
        <p className="login__sub">
          Autentifică-te pentru a vedea mașinile și solicitările tale.
        </p>

        <form onSubmit={handleSubmit} className="login__form">
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@firma.ro"
              required
            />
          </label>
          <label>
            Parolă
            <input
              type="password"
              value={parola}
              onChange={(e) => setParola(e.target.value)}
              placeholder="••••••••"
              required
            />
          </label>
          {eroare && <div className="login__error">{eroare}</div>}
          <button type="submit" className="btn btn--primary">Intră în cont</button>
        </form>

        <Link to="/" className="login__back">← Înapoi la site</Link>
      </div>
    </div>
  );
}
